export const plural = (word: string, amount: number) => `${word}${amount === 1 ? '' : 's'}`
